import React, { Component } from 'react';
import { Provider } from 'react-redux';
import ReduxThunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';
import Router from './routes';
import { loginCheck } from './actions/Auth/UserLoginCheck';

export default class App extends Component {

    constructor() {
        super();
        this.store = createStore(reducers, {}, applyMiddleware(ReduxThunk));
    }

    componentWillMount() {
        this.store.dispatch(loginCheck());
    }

    render() {
        return (
            <Provider store={this.store}>
                    <Router />
            </Provider>
        );
    }
}




// WEBPACK FOOTER //
// ./src/App.js